import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import JxLineEdit from '../../../../../JxControls/JxEdits/JxLineEdit';

/**
 * FilterEdit — JxLineEdit subclass with a filter icon prefix and a clear button suffix.
 * Client-side filter input for SearchDrawer.
 */
export default class FilterEdit extends JxLineEdit {

    getPrefix() {
        return <FilterListIcon sx={{ fontSize: 14 }} />;
    }

    getSuffix() {
        if (!this.getValue()) return null;
        return (
            <CloseIcon
                sx={{ fontSize: 14, cursor: 'pointer' }}
                onClick={() => this.props.onChange('')}
            />
        );
    }

    getPlaceholder() {
        return this.props.placeholder ?? 'Filter…';
    }
}
